import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/apiClient";
import { SlideshowLightbox } from "lightbox.js-react";
import Resizer from "react-image-file-resizer";
import { PDFDocument } from "pdf-lib";
import { TrashIcon } from "@heroicons/react/solid";
import { XCircleIcon } from "@heroicons/react/solid";

const AntecedentCriminel = ({ user, enabled }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  const location = useLocation();
  const [errors, setErrors] = useState({});
  let selectedForm = location.state?.selectedForm;
  const navigate = useNavigate(); // Initialize navigate hook

  // const [showTable, setShowTable] = useState(false);

  const [rows, setRows] = useState([
    { infractions: "", date: "", tribunal: "", commentaire: "" },
  ]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreviewUrl, setFilePreviewUrl] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const [hasSubmittedThisYearDeclaration, setHasSubmittedThisYearDeclaration] =
    useState(false);
  // const [isCoupableDeclaration, setIsCoupableDeclaration] = useState(false);
  const [typeDocumentDeclaration, setTypeDocumentDeclaration] = useState(null);
  const [hasSubmittedRapportPolice, setHasSubmittedRapportPolice] =
    useState(false);
  const [typeDocumentRapportPolice, setTypeDocumentRapportPolice] =
    useState(null);

  const [anneeDecAn, setAnneeDecAn] = useState(null);
  const [existMembreDecAn, setExistMembreDecAn] = useState(null);

  const [showPassword, setShowPassword] = useState(false);

  // useEffect(() => {
  //   const checkAllDemandes = async () => {
  //     try {
  //       const res = await apiFetch(
  //         `${process.env.REACT_APP_API_BASE_URL}/demande/check/${user.id}?anneeDecAn=${anneeDecAn}`
  //       );

  //       const result = await res.json();

  //       // 🔹 Déclaration annuelle
  //       setHasSubmittedThisYearDeclaration(
  //         result.declarationAnnuelle.hasSubmitted
  //       );
  //       setIsCoupableDeclaration(
  //         result.declarationAnnuelle.coupable === "oui"
  //       );
  //       setTypeDocumentDeclaration(
  //         result.declarationAnnuelle.coupable === "oui"
  //           ? result.declarationAnnuelle.typeDocument
  //           : null
  //       );

  //       // 🔹 Rapport de police
  //       setHasSubmittedRapportPolice(
  //         result.rapportPolice.hasSubmitted
  //       );
  //       setTypeDocumentRapportPolice(
  //         result.rapportPolice.typeDocument
  //       );

  //     } catch (err) {
  //       console.error(err);
  //       renderError?.("Impossible de vérifier vos demandes.");
  //     }
  //   };

  //   if (
  //     user?.id  &&
  //     (!selectedForm || selectedForm.etatDemande === "Brouillon")
  //   ) {
  //     checkAllDemandes();
  //   }
  // }, [user,anneeDecAn, selectedForm]);

  useEffect(() => {
    const checkDemandes = async () => {
      const res = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/demande/check/${user.id}?matricule=${user.employeeId}`,
      );

      const result = await res.json();

      setExistMembreDecAn(result.existMembreDecAn);
      setAnneeDecAn(result.anneeDecAn);

      setHasSubmittedThisYearDeclaration(
        result.declarationAnnuelle.hasSubmitted,
      );

      // setIsCoupableDeclaration(
      //   result.declarationAnnuelle.coupable === "oui"
      // );

      setTypeDocumentDeclaration(result.declarationAnnuelle.typeDocument);

      setHasSubmittedRapportPolice(result.rapportPolice.hasSubmitted);

      setTypeDocumentRapportPolice(result.rapportPolice.typeDocument);
    };

    if (
      user?.id &&
      (!selectedForm ||
        (selectedForm?.etatDemande === "Soumis" &&
          selectedForm?.typeDocument === "RecuDemande") ||
        selectedForm?.etatDemande === "Brouillon")
    ) {
      checkDemandes();
    }
  }, [user?.id, selectedForm]);

  // Add a new row to the table
  const addRow = () => {
    const newRows = [
      ...rows,
      { infractions: "", date: "", tribunal: "", commentaire: "" },
    ];
    setRows(newRows);
    setFormData({ ...formData, dispositions: newRows });
  };

  // Update row values
  const handleInputChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
    setFormData({ ...formData, dispositions: newRows });
  };

  // Remove a row
  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
    setFormData({ ...formData, dispositions: newRows });
  };

  const base64ToFile = (base64, filename, mimeType) => {
    // Remove the base64 data prefix (if it exists)
    const base64String = base64.split(",")[1]; // Get the part after the comma
    if (!base64String) {
      throw new Error("Invalid base64 string");
    }

    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });

    return file;
  };

  //   const handleFileUpload = async (e) => {
  //     const MAX_FILE_SIZE_MB = 5;
  //     const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // en octets

  //     const file = e.target.files[0];
  //     if (!file) return;

  //     const ALLOWED_TYPES = [
  //   "application/pdf",
  //   "image/jpeg",
  //   "image/jpg",
  //   "image/png"
  // ];

  // if (!ALLOWED_TYPES.includes(file.type)) {
  //   setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
  //   return;
  // }

  //     // --- Resize image ---
  //     const resizeImage = (file) =>
  //       new Promise((resolve) => {
  //         if (!file.type.includes('image')) return resolve(file);

  //         Resizer.imageFileResizer(
  //           file,
  //           1600,          // maxWidth
  //           1600,          // maxHeight
  //           'WEBP',        // format
  //           70,            // qualité
  //           0,             // rotation
  //           (uri) => {
  //             const resizedFile = new File([uri], file.name, { type: 'image/webp' });
  //             resolve(resizedFile);
  //           },
  //           'blob',
  //           200,           // minWidth
  //           200            // minHeight
  //         );
  //       });

  //     // --- Compress PDF ---
  //     const compressPDF = async (file) => {
  //       if (file.type !== 'application/pdf') return file;

  //       const arrayBuffer = await file.arrayBuffer();
  //       const pdfDoc = await PDFDocument.load(arrayBuffer);
  //       const compressedBytes = await pdfDoc.save(); // Re-encode
  //       const compressedFile = new File([compressedBytes], file.name, { type: 'application/pdf' });
  //       return compressedFile;
  //     };

  //     // --- Process file ---
  //     const processFile = async (file) => {
  //       if (file.type.includes('image')) {
  //         return await resizeImage(file);
  //       } else if (file.type === 'application/pdf') {
  //         return await compressPDF(file);
  //       }
  //       return file;
  //     };

  //     // --- Traitement ---
  //     const processedFile = await processFile(file);

  //     // --- Vérification après compression ---
  //     if (processedFile.size > MAX_FILE_SIZE) {
  //       setFileUploadError(
  //         `Le fichier (même après compression) dépasse ${MAX_FILE_SIZE_MB} Mo.`
  //       );
  //       return;
  //     }

  //     // --- Si taille OK ---
  //     setFileUploadError("");
  //     setUploadedFile(processedFile);
  //     setFilePreviewUrl(URL.createObjectURL(processedFile));

  //     const newFormData = {
  //       ...formData,
  //       uploadedFile: {
  //         filename: processedFile.name,
  //         contentType: processedFile.type,
  //         data: "", // backend will fill
  //       },
  //     };

  //     setFormData(newFormData);
  //     setErrors("");
  //     // setFormData({ ...formData, uploadedFile: file });
  //   };

  const handleFileUpload = async (e) => {
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

    const file = e.target.files[0];
    if (!file) return;

    const ALLOWED_TYPES = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!ALLOWED_TYPES.includes(file.type)) {
      setFileUploadError("Formats acceptés : PDF, JPG, JPEG, PNG.");
      return;
    }

    const resizeImage = (file) =>
      new Promise((resolve) => {
        if (!file.type.includes("image")) return resolve(file);

        Resizer.imageFileResizer(
          file,
          1600,
          1600,
          "WEBP",
          70,
          0,
          (uri) => {
            const resizedFile = new File([uri], file.name, {
              type: "image/webp",
            });
            resolve(resizedFile);
          },
          "blob",
          200,
          200,
        );
      });

    const compressPDF = async (file) => {
      if (file.type !== "application/pdf") return file;

      if (file.type === "application/pdf") {
        return file; // 🔥 ne touche pas
      }
    };

    const processFile = async (file) => {
      if (file.type.includes("image")) {
        return await resizeImage(file);
      } else if (file.type === "application/pdf") {
        return await compressPDF(file);
      }
      return file;
    };

    try {
      const processedFile = await processFile(file);

      if (processedFile.size > MAX_FILE_SIZE) {
        setFileUploadError(
          `Le fichier dépasse la taille maximale permise de ${MAX_FILE_SIZE_MB} Mo.`,
        );
        return;
      }

      setFileUploadError("");
      setUploadedFile(processedFile);
      setFilePreviewUrl(URL.createObjectURL(processedFile));

      setFormData((prev) => ({
        ...prev,
        uploadedFile: {
          filename: processedFile.name,
          contentType: processedFile.type,
          data: "",
        },
      }));

      setErrors("");
    } catch (error) {
      console.error(error);
      setFileUploadError(
        error.message ||
          "Une erreur est survenue lors du téléversement du fichier.",
      );
    }
  };

  const handleFileDelete = () => {
    setUploadedFile(null);
    setFilePreviewUrl(null);
    setShowPopup(false);

    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-DECA`;
  };

  const initialFormData = {
    userId: "",
    nom: "",
    numeroFormulaire: generateNumeroFormulaire(),
    // declarationAnnuelle: selectedForm?.declarationAnnuelle || false,
    // rapportPolice: selectedForm?.rapportPolice || false,
    typeDemande: selectedForm?.typeDemande || "",
    typeDocument: selectedForm?.typeDocument || "",
    coupable: selectedForm?.coupable || "",
    dateDocumentPolice: selectedForm?.dateDocumentPolice || "",
    declarationExacteEtComplete:
      selectedForm?.declarationExacteEtComplete || "non",
    // hasCurrentPoliceCheck : selectedForm?.hasCurrentPoliceCheck || "",
    dateDeclaration: new Date().toISOString().split("T")[0] + "",
    etatDemande: "Soumis",
    annee: "",
    uploadedFile: null,
    motdepasseFile: selectedForm?.motdepasseFile || "",
    traitant: selectedForm?.traitant || [],
    dateSoumission: "",
    dispositions: [],
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  const showTable = formData.coupable === "oui";

  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId,
        posteOccupe: user.jobTitle,
      }));
    }

    if (selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        numeroFormulaire: selectedForm.numeroFormulaire, // Merge selectedForm data into formData
      }));
      // console.log(selectedForm._id)
    }
    if (anneeDecAn) {
      setFormData((prevData) => ({
        ...prevData,
        annee: anneeDecAn,
      }));
    }
    if (selectedForm && selectedForm.coupable === "oui") {
      // setShowTable(true);     here

      // Prefill dispositions table
      if (selectedForm.dispositions && selectedForm.dispositions.length > 0) {
        setRows(selectedForm.dispositions); // Populate rows for the table
        setFormData((prevData) => ({
          ...prevData,
          dispositions: selectedForm.dispositions, // Update formData with prefilled dispositions
        }));
      }
    }
    if (
      selectedForm?.uploadedFile?.data &&
      selectedForm?.uploadedFile?.contentType &&
      selectedForm?.uploadedFile?.filename
    ) {
      const base64String = `data:${selectedForm.uploadedFile.contentType};base64,${selectedForm.uploadedFile.data}`;
      const file = base64ToFile(
        base64String,
        selectedForm.uploadedFile.filename,
        selectedForm.uploadedFile.contentType,
      );

      setUploadedFile(file);
      setFilePreviewUrl(URL.createObjectURL(file));
    }

    // ✅ AJOUT DE LA RÈGLE MÉTIER ICI
    const shouldDisableDeclarationAnnuelle =
      hasSubmittedThisYearDeclaration && !selectedForm;

    if (shouldDisableDeclarationAnnuelle) {
      setFormData((prevData) => ({
        ...prevData,
        typeDemande:
          prevData.typeDemande === "declarationAnnuelle"
            ? ""
            : prevData.typeDemande,
      }));
    }

    if (
      existMembreDecAn === false &&
      selectedForm &&
      (selectedForm.etatDemande === "Brouillon" ||
        (selectedForm.typeDocument === "RecuDemande" &&
          selectedForm.etatDemande === "Soumis")) &&
      selectedForm.typeDemande === "declarationAnnuelle"
    ) {
      setFormData((prevData) => ({
        ...prevData,
        typeDemande:
          prevData.typeDemande === "declarationAnnuelle"
            ? ""
            : prevData.typeDemande,
        coupable: "",
        dateDocumentPolice: "",
        typeDocument: "",
      }));
    }
  }, [user, selectedForm, hasSubmittedThisYearDeclaration, existMembreDecAn]); // Add selectedForm to the dependency array

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setErrors(""); // reset errors

    // 🔹 EXCEPTION : oui / non uniquement pour declarationExacteEtComplete
    if (name === "declarationExacteEtComplete" && type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        declarationExacteEtComplete: checked ? "oui" : "non",
      }));
      return;
    }

    setFormData((prevData) => {
      let updatedData = { ...prevData };

      // ✅ Gestion générique
      updatedData[name] = type === "checkbox" ? checked : value;

      // 🔒 EXCLUSIVITÉ DES CHECKBOXES

      //-- Si typeDemande change
      if (name === "typeDemande") {
        handleFileDelete();
        setRows([{ infractions: "", date: "", tribunal: "", commentaire: "" }]);

        updatedData = {
          ...updatedData,
          coupable: "",
          dispositions: [],
          // hasCurrentPoliceCheck: "",
          typeDocument: "",
          dateDocumentPolice: "",
          uploadedFile: null,
        };
        if (value === "declarationAnnuelle") {
          updatedData = {
            ...updatedData,
            annee: anneeDecAn,
          };
        } else {
          updatedData = {
            ...updatedData,
            annee: new Date().getFullYear(),
          };
        }
      }

      // -- Si coupable est modifié
      if (name === "coupable" && value === "non") {
        setRows([{ infractions: "", date: "", tribunal: "", commentaire: "" }]);

        const shouldResetDocument = formData.typeDemande !== "rapportPolice";

        if (shouldResetDocument) {
          handleFileDelete();
        }

        updatedData = {
          ...updatedData,
          dispositions: [],
          ...(shouldResetDocument && {
            typeDocument: "",
            dateDocumentPolice: "",
            uploadedFile: null,
          }),
        };
      }

      return updatedData;
    });
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType, // Action type can be either "Soumettre" or "Enregistrer"
      dateSoumission: currentDate, // Send as a Date object
    };

    const method = location.state?.selectedForm ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "AntecedentCriminel";
    const url = location.state?.selectedForm
      ? `${process.env.REACT_APP_API_BASE_URL}/formFile/${location.state.selectedForm._id}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/formFile?form=${formType}`; // Use POST for creating a new form

    // console.log("uploadedFile : ", uploadedFile);

    const formDataToSend = new FormData();

    // Append form data fields to FormData (use JSON.stringify for nested objects if needed)
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));
    if (uploadedFile) {
      const blob = new Blob([uploadedFile], { type: uploadedFile.type });
      formDataToSend.append("file", blob, uploadedFile.name);
      // console.log(uploadedFile);
    }
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });
      // const response = await apiFetch(url, {
      //   method: method,
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(updatedFormData),
      // });

      if (response.ok) {
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 3000);
        });

        if (
          updatedFormData.etatDemande !== "Brouillon" &&
          updatedFormData.etatDemande !== ""
        ) {
          const initialFormData = {
            nom: user.displayName,
            userId: user.id,
            numeroFormulaire: generateNumeroFormulaire(),
            // declarationAnnuelle: false,
            // rapportPolice: false,
            coupable: "",
            dateDocumentPolice: "",
            declarationExacteEtComplete: "non",
            typeDemande: "",
            typeDocument: "",
            dateDeclaration: new Date().toISOString().split("T")[0] + "",
            etatDemande: "Soumis",
            traitant: [],
            dateSoumission: "",
            dispositions: [],
          };
          setFormData(initialFormData);
          setRows([
            { infractions: "", date: "", tribunal: "", commentaire: "" },
          ]);
          handleFileDelete();
          // setShowTable(false); here
          setErrors("");

          navigate("/demande", { state: { selectedForm: null } });
        }

        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    } finally {
      setIsSubmitting(false); // 🔓 CRUCIAL
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return; // 🚫 bloque double click
    if (!validateForm()) return; // Stop if validation fails
    setIsSubmitting(true); // 🔒 lock
    handleFormAction(e, "Soumis");
    // console.log(formData)
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
  };

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.",
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.typeDemande) {
      newErrors.choixDemande = "Veuillez choisir une option.";
    }
    if (formData.coupable === "") {
      newErrors.Coupable = "Veuillez cocher l'une des cases selon le cas. ";
    }
    if (
      (formData.coupable === "oui" ||
        formData.typeDemande === "rapportPolice") &&
      !formData.typeDocument
    ) {
      newErrors.typeDocument = "Veuillez indiquer le type de document soumis.";
    }

    if (formData.typeDocument !== "" && !formData.dateDocumentPolice) {
      newErrors.dateDocumentPolice = "Veuillez cocher la case ci-dessous.";
    }

    if (formData.declarationExacteEtComplete === "non") {
      newErrors.Confirme = "Veuillez cocher la case ci-dessous.";
    }
    if (formData.typeDocument !== "" && !uploadedFile) {
      newErrors.uploadedFile = "Le fichier est obligatoire.";
    }

    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/

  const handleClear = () => {
    // setFormData(initialFormData); // Réinitialise le formulaire à son état initial
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        declarationAnnuelle: false,
        rapportPolice: false,
        typeDemande: "",
        coupable: "",
        dateDocumentPolice: "",
        declarationExacteEtComplete: "non",
        // hasCurrentPoliceCheck : "",
        typeDocument: "",
        motdepasseFile: "",
        dateDeclaration: new Date().toISOString().split("T")[0] + "",
        etatDemande: "Soumis",
        dateSoumission: "",
        dispositions: [],
      }));
    }
    setRows([{ infractions: "", date: "", tribunal: "", commentaire: "" }]);
    // setShowTable(false); here
    handleFileDelete();
    setErrors("");
  };

  if (
    (!enabled && !selectedForm) ||
    (!enabled && selectedForm && selectedForm.etatDemande === "Brouillon")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire Antécédents criminels fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé.
        </p>
      </div>
    );
  }
  /************************************************************************/

  /***Condition */

  const isFormLocked = selectedForm && selectedForm.etatDemande === "Soumis";

  const AlertMessage = ({ type = "info", children }) => {
    const styles = {
      success: "border-l-4 border-green-500 bg-green-50/60 text-green-900",
      error: "border-l-4 border-red-500 bg-red-50/60 text-red-900",
      warning: "border-l-4 border-amber-500 bg-amber-50/60 text-amber-900",
      info: "border-l-4 border-blue-500 bg-blue-50/60 text-blue-900",
    };

    return (
      <div
        className={`rounded-lg px-4 py-3 text-sm leading-relaxed ${styles[type]} w-1/2`}
      >
        {children}
      </div>
    );
  };

  return (
    <div className="relative min-h-screen p-8 bg-white rounded-lg shadow-lg">
      <form
        onSubmit={handleSubmit}
        className="maxn-h-screen p-8 bg-gray-100 rounded-lg shadow-lg"
      >
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]"></div>

          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-2 w-full sm:w-3/4 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]"></div>

          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateDeclaration"
              name="dateDeclaration"
              value={formData.dateDeclaration}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-2 w-full sm:w-3/4 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>

        <div className="w-full flex justify-center mt-6 mb-20">
          <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
            <p className="text-md font-bold flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
                />
              </svg>
              Formulaire d'antécédents criminels
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm">
          <h2 className="text-xl font-semibold text-blue-900 mb-2">
            Bienvenue aux membres du personnel du Conseil scolaire Viamonde
          </h2>

          <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
            <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
              🔒 Confidentiel
            </span>
            <span>Une fois rempli</span>
          </div>

          <p className="text-gray-700 leading-relaxed mb-3">
            Conformément à la <strong>Loi sur l’éducation</strong>, tous les
            membres du personnel doivent soumettre une déclaration écrite et
            signée une fois par année.
          </p>

          <p className="text-gray-700 leading-relaxed">
            Pour toute question, veuillez communiquer avec l’équipe des
            ressources humaines :
            <br />
            <a
              href="mailto:declaration@csviamonde.ca"
              className="text-blue-600 font-medium hover:underline"
            >
              declaration@csviamonde.ca
            </a>
          </p>

          <p className="mt-4 text-gray-800 font-medium">
            — L’équipe des ressources humaines
          </p>
        </div>

        <div className="space-y-4">
          {/* Déclaration annuelle */}
          <label
            htmlFor="declarationAnnuelle"
            className={`relative flex gap-4 p-5 rounded-2xl border transition-all
    ${
      hasSubmittedThisYearDeclaration || !existMembreDecAn
        ? "bg-gray-100 border-gray-200 opacity-60 cursor-not-allowed"
        : formData.typeDemande === "declarationAnnuelle"
          ? "border-blue-500 bg-blue-50 shadow-sm"
          : "border-gray-200 hover:border-blue-400 hover:bg-gray-50 cursor-pointer"
    }
  `}
          >
            <input
              type="radio"
              id="declarationAnnuelle"
              name="typeDemande"
              value="declarationAnnuelle"
              checked={formData.typeDemande === "declarationAnnuelle"}
              onChange={handleChange}
              disabled={
                hasSubmittedThisYearDeclaration ||
                isFormLocked ||
                !existMembreDecAn
              }
              className="mt-1 h-5 w-5 text-blue-600 focus:ring-blue-500"
            />

            <div>
              <p className="font-medium text-gray-900">
                Déclaration annuelle des antécédents criminels
              </p>
              <p className="text-sm text-gray-500">
                À soumettre une seule fois par année
              </p>
            </div>
          </label>

          {/* Message explicatif */}
          {/* ❌ Pas autorisé */}
          {(!selectedForm ||
            selectedForm?.typeDemande === "declarationAnnuelle") &&
            !existMembreDecAn && (
              <AlertMessage type="error">
                Vous n’êtes pas autorisé à soumettre une déclaration annuelle.
              </AlertMessage>
            )}

          {/* ✅ Déjà soumis */}
          {!selectedForm &&
            hasSubmittedThisYearDeclaration &&
            typeDocumentDeclaration !== "RecuDemande" && (
              <AlertMessage type="success">
                Une déclaration annuelle a déjà été soumise pour l’année en
                cours.
                <br />
                Vous ne pouvez en soumettre qu’une seule par année.
              </AlertMessage>
            )}

          {/* ⚠️ Reçu de demande */}
          {!selectedForm &&
            hasSubmittedThisYearDeclaration &&
            typeDocumentDeclaration === "RecuDemande" && (
              <AlertMessage type="warning">
                Une déclaration annuelle a été soumise avec un reçu de demande.
                <br />
                Veuillez modifier votre demande existante afin d’y joindre le
                certificat de police requis.
              </AlertMessage>
            )}

          {/* Rapport de police */}
          <label
            htmlFor="rapportPolice"
            className={`relative flex gap-4 p-5 rounded-2xl border transition-all
    ${
      hasSubmittedRapportPolice
        ? "bg-gray-100 border-gray-200 opacity-60 cursor-not-allowed"
        : formData.typeDemande === "rapportPolice"
          ? "border-blue-500 bg-blue-50 shadow-sm"
          : "border-gray-200 hover:border-blue-400 hover:bg-gray-50 cursor-pointer"
    }
  `}
          >
            <input
              type="radio"
              id="rapportPolice"
              name="typeDemande"
              value="rapportPolice"
              checked={formData.typeDemande === "rapportPolice"}
              onChange={handleChange}
              disabled={hasSubmittedRapportPolice || isFormLocked}
              className="mt-1 h-5 w-5 text-blue-600 focus:ring-blue-500"
            />

            <div>
              <p className="font-medium text-gray-900">Rapport de police</p>
              <p className="text-sm text-gray-500">
                Document requis selon votre situation
              </p>
            </div>
          </label>

          {(!selectedForm || selectedForm?.typeDemande === "RecuDemande") &&
            hasSubmittedRapportPolice &&
            typeDocumentRapportPolice === "CertificatPolice" && (
              <AlertMessage type="success">
                Un rapport de police a déjà été soumis.
              </AlertMessage>
            )}

          {!selectedForm &&
            hasSubmittedRapportPolice &&
            typeDocumentRapportPolice === "RecuDemande" && (
              <AlertMessage type="warning">
                Un rapport de police a déjà été soumis avec un reçu de demande.
                <br />
                Afin de pouvoir soumettre le certificat de police, veuillez
                retourner à votre demande déjà soumise et la modifier pour y
                joindre le document requis.
              </AlertMessage>
            )}

          {renderError("choixDemande")}
        </div>

        {/* {(formData.declarationAnnuelle || formData.rapportPolice) && ( */}
        {formData.typeDemande !== "" && (
          <>
            <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2 pt-10">
              <div className="w-[60%]">
                <label
                  htmlFor="nom"
                  className="block text-m font-medium text-blue-900"
                >
                  Je, {formData.nom}, déclare solennellement que :
                </label>
              </div>
            </div>

            <div className="space-y-4">
              {/* NON */}
              <label
                className={`flex items-start gap-4 p-4 border rounded-xl cursor-pointer transition
       ${
         formData.coupable === "non"
           ? "border-blue-600 bg-blue-50"
           : "border-gray-300 hover:border-blue-400 hover:bg-gray-50"
       }
          ${isFormLocked ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
        `}
              >
                <input
                  type="radio"
                  name="coupable"
                  value="non"
                  checked={formData.coupable === "non"}
                  onChange={handleChange}
                  disabled={isFormLocked}
                  className="mt-1 w-5 h-5 text-blue-600 focus:ring-blue-500"
                />
                {formData.typeDemande === "rapportPolice" ? (
                  <>
                    Je n’ai pas été reconnu ou reconnue coupable d’une
                    infraction au Code criminel du Canada à la date de
                    délivrance du certificat de police soumis.
                  </>
                ) : (
                  <>
                    Je n’ai pas été reconnu ou reconnue coupable d’une
                    disposition au Code criminel du Canada depuis ma dernière
                    déclaration annuelle ou de mon dernier relevé d’antécédents
                    criminels soumis au Conseil ou à l’Ordre des enseignantes et
                    enseignants de l’Ontario, le cas échéant.
                  </>
                )}
              </label>

              {/* OUI */}
              <label
                className={`flex items-start gap-4 p-4 border rounded-xl cursor-pointer transition
      ${
        formData.coupable === "oui"
          ? "border-red-600 bg-red-50"
          : "border-gray-300 hover:border-red-400 hover:bg-gray-50"
      }
          ${isFormLocked ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
        `}
              >
                <input
                  type="radio"
                  name="coupable"
                  value="oui"
                  checked={formData.coupable === "oui"}
                  onChange={handleChange}
                  className="mt-1 w-5 h-5 text-red-600 focus:ring-red-500"
                  disabled={isFormLocked}
                />
                {formData.typeDemande === "rapportPolice" ? (
                  <>
                    À la date de délivrance du certificat de police soumis, j’ai
                    été reconnu ou reconnue coupable d’au moins une infraction
                    au Code criminel du Canada.
                  </>
                ) : (
                  <>
                    Depuis ma dernière déclaration annuelle ou mon dernier
                    relevé d’antécédents criminels soumis au Conseil ou à
                    l’Ordre des enseignantes et enseignants de l’Ontario, le cas
                    échéant, j’ai été reconnu ou reconnue coupable d’au moins
                    une disposition au Code criminel du Canada.
                  </>
                )}
              </label>

              {renderError("Coupable")}
            </div>

            {/* Conditional Table */}
            {showTable && (
              <div className="mt-8 bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">
                    Détails des dispositions
                  </h3>

                  <span className="text-sm text-gray-500">
                    Champs obligatoires (*)
                  </span>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="border-b text-gray-600">
                      <tr>
                        <th className="text-left py-3">Infraction *</th>
                        <th className="text-left py-3">Date *</th>
                        <th className="text-left py-3">Tribunal *</th>
                        <th className="text-left py-3">Commentaire *</th>
                        <th className="py-3"></th>
                      </tr>
                    </thead>

                    <tbody className="divide-y">
                      {rows.map((row, index) => (
                        <tr key={index} className="hover:bg-gray-50 transition">
                          <td className="py-3 pr-2">
                            <input
                              type="text"
                              placeholder="Infraction"
                              value={row.infractions}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "infractions",
                                  e.target.value,
                                )
                              }
                              className="w-full rounded-lg border border-gray-300 px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-500"
                              required
                              disabled={
                                selectedForm &&
                                selectedForm.etatDemande === "Soumis" &&
                                selectedForm.typeDocument !== "RecuDemande"
                              }
                            />
                          </td>

                          <td className="py-3 pr-2">
                            <input
                              type="date"
                              value={row.date}
                              onChange={(e) =>
                                handleInputChange(index, "date", e.target.value)
                              }
                              className="w-full rounded-lg border border-gray-300 px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-500"
                              required
                              disabled={
                                selectedForm &&
                                selectedForm.etatDemande === "Soumis" &&
                                selectedForm.typeDocument !== "RecuDemande"
                              }
                            />
                          </td>

                          <td className="py-3 pr-2">
                            <input
                              type="text"
                              placeholder="Lieu du tribunal"
                              value={row.tribunal}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "tribunal",
                                  e.target.value,
                                )
                              }
                              className="w-full rounded-lg border border-gray-300 px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-500"
                              required
                              disabled={
                                selectedForm &&
                                selectedForm.etatDemande === "Soumis" &&
                                selectedForm.typeDocument !== "RecuDemande"
                              }
                            />
                          </td>

                          <td className="py-3 pr-2">
                            <input
                              type="text"
                              placeholder="Commentaire"
                              value={row.commentaire}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "commentaire",
                                  e.target.value,
                                )
                              }
                              className="w-full rounded-lg border border-gray-300 px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-500"
                              required
                              disabled={
                                selectedForm &&
                                selectedForm.etatDemande === "Soumis" &&
                                selectedForm.typeDocument !== "RecuDemande"
                              }
                            />
                          </td>

                          <td className="py-3 text-center">
                            {index > 0 &&
                              !(
                                selectedForm &&
                                selectedForm.etatDemande === "Soumis" &&
                                selectedForm.typeDocument !== "RecuDemande"
                              ) && (
                                <button
                                  type="button"
                                  onClick={() => removeRow(index)}
                                  className="text-red-600 hover:text-red-800 transition text-lg"
                                  title="Supprimer la ligne"
                                >
                                  ✕
                                </button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button
                  type="button"
                  onClick={addRow}
                  disabled={
                    selectedForm &&
                    selectedForm.etatDemande === "Soumis" &&
                    selectedForm.typeDocument !== "RecuDemande"
                  }
                  className="mt-6 inline-flex items-center gap-2 rounded-lg
        bg-blue-600 px-4 py-2 text-white font-medium
        hover:bg-blue-700 transition"
                >
                  ➕ Ajouter une disposition
                </button>
              </div>
            )}
          </>
        )}

        {(formData.coupable === "oui" ||
          formData.typeDemande === "rapportPolice") && (
          <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
            <div className="w-[90%] ">
              <label
                htmlFor="dateEntreeEnVigueur"
                className="block text-sm font-medium text-blue-900"
              >
                Type de document<span className="text-xl text-red-900">*</span>{" "}
                :
              </label>
              <select
                id="typeDocument"
                name="typeDocument"
                value={formData.typeDocument}
                onChange={handleChange}
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              >
                <option value="">— Séléctionner —</option>
                <option value="CertificatPolice">
                  Certificat de police (document officiel)
                </option>

                <option value="RecuDemande">
                  Accusé de réception de la demande de certificat de police
                </option>
              </select>
              {renderError("typeDocument")}
            </div>
          </div>
        )}

        {formData.typeDocument !== "" && (
          <>
            <div className="mt-5 w-3/4 grid grid-cols-2 gap-0 pt-[1.5%]">
              <div className="w-3/5 ">
                <label
                  htmlFor="dateDocumentPolice"
                  className="block text-sm font-medium text-blue-900"
                >
                  {formData.typeDocument === "CertificatPolice" ? (
                    <>
                      À quelle date votre vérification de dossier de police
                      a-t-elle été effectuée
                      <span className="text-gray-600 font-normal">
                        {" "}
                        (au cours des 6 derniers mois)
                      </span>
                    </>
                  ) : (
                    <>
                      À quelle date avez-vous soumis votre demande de certificat
                      de police
                    </>
                  )}
                  <span className="text-xl text-red-900"> *</span>
                </label>
                <input
                  type="date"
                  id="dateDocumentPolice"
                  name="dateDocumentPolice"
                  value={formData.dateDocumentPolice}
                  onChange={handleChange}
                  min={
                    new Date(new Date().setMonth(new Date().getMonth() - 6))
                      .toISOString()
                      .split("T")[0]
                  }
                  max={new Date().toISOString().split("T")[0]}
                  className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                />
                {renderError("dateDocumentPolice")}
              </div>
            </div>

            <>
              <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
                <div className="w-3/5">
                  <label
                    htmlFor="fileUpload"
                    className="block text-sm font-medium text-blue-900 mb-2"
                  >
                    Fichier<span className="text-xl text-red-900">*</span> :
                  </label>
                  <div className="relative">
                    <input
                      type="file"
                      id="fileUpload"
                      name="fileUpload"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileUpload}
                      className="absolute inset-0 opacity-0 cursor-pointer"
                    />
                    <button className="w-full px-4 py-2 border border-blue-500 rounded-lg text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 cursor-pointer">
                      Choisir un fichier
                    </button>
                  </div>
                  <p className="text-sm text-gray-500 mt-1">
                    Formats acceptés : PDF, JPG, JPEG, PNG.
                  </p>
                  {renderError("uploadedFile")}
                  {fileUploadError && (
                    <p style={{ color: "red", marginTop: "0.5rem" }}>
                      {fileUploadError}
                    </p>
                  )}
                </div>
                <div className="w-4/5 ">
                  <label
                    htmlFor="motdepasseFile"
                    className="block text-sm font-medium text-blue-900"
                  >
                    Veuillez indiquer le mot de passe du PDF, s’il y a lieu
                  </label>
                  <div className="relative mt-2">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="motdepasseFile"
                      name="motdepasseFile"
                      value={formData.motdepasseFile ?? ""}
                      onChange={handleChange}
                      className="w-full p-3 pr-10 border border-gray-200 rounded-xl shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
                      placeholder="Entrez le mot de passe du PDF"
                    />

                    {/* Bouton œil professionnel */}
                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                      aria-label={
                        showPassword
                          ? "Masquer le mot de passe"
                          : "Afficher le mot de passe"
                      }
                    >
                      {showPassword ? (
                        // Eye-off icon
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7
               1.02-2.32 2.82-4.27 5.125-5.675M6.1 6.1A9.969 9.969 0 0112 5
               c5 0 9.27 3.11 11 7a10.97 10.97 0 01-4.145 5.355M15 12a3 3 0 01-3 3
               m0-6a3 3 0 013 3m6 6L4 4.5"
                          />
                        </svg>
                      ) : (
                        // Eye icon
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5
               c4.478 0 8.268 2.943 9.542 7
               -1.274 4.057-5.064 7-9.542 7
               -4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      )}
                    </button>
                  </div>
                  {/* <textarea
                        className="mt-2 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                        rows="1"
                        id="motdepasseFile"
                        name="motdepasseFile"
                        value={formData.motdepasseFile ?? ""}
                        onChange={handleChange}
                    // readOnly={isReadOnlyRh}
                    /> */}
                </div>
              </div>

              {uploadedFile && (
                <div className="mt-3 w-3/4 flex items-center space-x-4">
                  {/* View Document Button */}
                  <p
                    className="border rounded-lg px-4 py-2 w-[30%] bg-blue-900 text-white cursor-pointer inline-block hover:bg-blue-700 transition duration-200"
                    onClick={() => setShowPopup(true)}
                  >
                    <span className="font-medium">Voir le document: </span>
                    {uploadedFile.name}
                  </p>

                  {/* Delete File Button with Trash Icon */}
                  <button
                    onClick={handleFileDelete}
                    className="w-10 h-10 border border-red-500 text-red-600 rounded-lg flex items-center justify-center transition duration-200"
                  >
                    <TrashIcon className="w-7 h-7" />{" "}
                    {/* Heroicons Trash Icon */}
                  </button>
                </div>
              )}

              {/* Popup with file preview */}
              {showPopup && uploadedFile && (
                <>
                  {/* Background overlay */}
                  <div
                    className="fixed  inset-0 bg-black bg-opacity-50 z-40"
                    onClick={closePopup}
                  ></div>

                  {/* Centered popup */}
                  <div className="fixed w-[60%] h-[80%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 bg-white border shadow-lg rounded-lg z-50">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800">
                          Aperçu du fichier
                        </h3>
                        {uploadedFile.type.startsWith("image/") && (
                          <p className="text-sm text-gray-500">
                            Cliquez sur l’image pour l’agrandir
                          </p>
                        )}
                      </div>
                      <button
                        onClick={closePopup}
                        className="text-gray-500 hover:text-gray-700 font-bold text-xl"
                      >
                        X
                      </button>
                    </div>

                    {/* Display preview based on file type */}
                    {uploadedFile.type.startsWith("image/") && (
                      <>
                        <SlideshowLightbox className="mx-auto">
                          <img
                            src={filePreviewUrl}
                            alt="Aperçu"
                            className="max-w-full max-h-[500px] rounded-lg border cursor-zoom-in"
                          />
                        </SlideshowLightbox>
                      </>
                    )}

                    {uploadedFile.type === "application/pdf" && (
                      <iframe
                        src={filePreviewUrl}
                        title="PDF preview"
                        className="w-[100%] h-[90%] border mt-4"
                      ></iframe>
                    )}

                    {!uploadedFile.type.startsWith("image/") &&
                      !uploadedFile.type.includes("pdf") && (
                        <p className="text-sm text-gray-800 mt-4">
                          Preview not available for this file type.
                        </p>
                      )}
                  </div>
                </>
              )}
            </>
          </>
        )}

        {formData.typeDemande && (
          <div className="bg-white border border-gray-200 rounded-2xl p-6 mb-8 shadow-sm mt-10">
            {/* Avis légal */}
            <h3 className="text-lg font-semibold text-blue-900 mb-2">
              🔐 Avis de confidentialité
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              Conformément à l’article 29(2) de la{" "}
              <strong>
                Loi sur l’accès à l’information municipale et la protection de
                la vie privée
              </strong>
              , les renseignements personnels demandés par l’entremise de ce
              formulaire électronique sont recueillis en vertu du Règlement
              521/01, tel qu’amendé par le Règlement de l’Ontario 322/03, de la
              Loi sur l’éducation, L.R.O. 1990, chap. <strong>E.2.</strong> Ces
              renseignements personnels permettront de déterminer si le membre
              du personnel concerné est admissible à un emploi au sein de
              l’organisation.
            </p>

            <p className="text-sm text-gray-600 leading-relaxed">
              Ces renseignements ne seront utilisés que pour les fins pour
              lesquelles ils ont été recueillis ou à des fins compatibles.
            </p>

            <div className="mt-4 text-sm text-gray-700">
              <p>
                📩 Pour toute question relative à la collecte :
                <br />
                <a
                  href="mailto:demandevieprivee@csviamonde.ca"
                  className="text-blue-600 font-medium hover:underline"
                >
                  demandevieprivee@csviamonde.ca
                </a>
              </p>

              <p className="mt-2">
                ♿ Pour de l’aide avec l’accessibilité :
                <br />
                <a
                  href="mailto:accessibilite@csviamonde.ca"
                  className="text-blue-600 font-medium hover:underline"
                >
                  accessibilite@csviamonde.ca
                </a>
              </p>
            </div>

            <hr className="my-6 border-gray-200" />

            {/* Déclaration */}
            <h3 className="text-lg font-semibold text-blue-900 mb-2">
              📄 Déclaration annuelle
            </h3>

            <p className="text-sm text-gray-500 mb-2">
              H01 – Déclaration annuelle d’infraction 3800-48_Rév.2026-03
            </p>
            <p className="text-sm text-gray-500 mb-2">
              Copie originale : Dossier du membre
            </p>

            <p className="text-gray-700 leading-relaxed mb-4">
              Afin de satisfaire aux exigences du Règlement de l’Ontario 521/01,
              tel qu’amendé par le Règlement de l’Ontario 322/03 et conformément
              à la Loi sur le casier judiciaire, je suis conscient ou consciente
              que je dois déclarer toute culpabilité dont j’ai fait l’objet pour
              une disposition prévue au Code criminel canadien, peu importe la
              date, la gravité et le contexte l’entourant.
              <br />
              <br />
              En conséquence, j’atteste que les informations fournies sont
              exactes et complètes. Je suis conscient ou consciente qu’une
              fausse déclaration pourrait entraîner des conséquences sérieuses.
            </p>

            {/* Confirmation */}
            <div className="flex items-start gap-3 mt-4">
              <input
                type="checkbox"
                id="declarationExacteEtComplete"
                name="declarationExacteEtComplete"
                className="mt-1 w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                onChange={handleChange}
                checked={formData.declarationExacteEtComplete === "oui"}
              />
              <label
                htmlFor="declarationExacteEtComplete"
                className="text-gray-800 leading-snug"
              >
                Je confirme que toutes les données que je fournis au présent
                formulaire sont complètes et exactes.
              </label>
            </div>

            {renderError("Confirme")}
          </div>
        )}

        {/* Privacy Statement */}
        {formData.typeDemande && (
          <div className="flex justify-start mt-4">
            {/* Left-aligned Buttons */}
            <div className="flex gap-4 mt-6">
              {/* Save Button */}
              {/* Reset Button */}
              {/* {(selectedForm?.etatDemande !== "Soumis") && (
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
            >
              Réinitialiser
            </button>)} */}

              {selectedForm?.etatDemande !== "Soumis" && (
                <button
                  type="button"
                  onClick={handleSave}
                  disabled={isSubmitting}
                  className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      isSubmitting
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-gray-700 text-white hover:bg-gray-600 active:scale-95"
                    }
                    `}
                >
                  {/* {isSubmitting && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    )} */}
                  Enregistrer
                </button>
              )}

              {/* Soumettre */}
              <button
                type="submit"
                disabled={isSubmitting}
                className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      isSubmitting
                        ? "bg-green-300 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-500 active:scale-95"
                    }
                `}
              >
                {isSubmitting && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Soumettre
              </button>
            </div>
          </div>
        )}

        {/* </>)} */}
      </form>
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}

      {existMembreDecAn === null && (
        <>
          {/* Overlay léger (optionnel) */}
          <div className="absolute inset-0 z-40 bg-white/40 backdrop-blur-sm"></div>

          {/* Loader top fixed */}
          <div className="fixed top-4 left-1/2 z-50 -translate-x-1/2">
            <div className="flex items-center gap-3 rounded-full bg-white px-5 py-3 shadow-xl border border-gray-200">
              {/* Spinner */}
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>

              {/* Text */}
              <span className="text-sm font-medium text-gray-700">
                Chargement en cours… {existMembreDecAn}
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AntecedentCriminel;
